(() => {
  const placeActions = (root = document) => {
    root.querySelectorAll('.productView').forEach((view) => {
      const images = view.querySelector('.productView-images');
      const actions = view.querySelector('.productView-buttons');
      if (!images || !actions || actions.classList.contains('achaki-image-actions')) return;
      actions.classList.add('achaki-image-actions');
      images.appendChild(actions);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => placeActions(), { once: true });
  else placeActions();
  document.addEventListener('shopify:section:load', (event) => placeActions(event.target));
})();